module.exports = __webpack_public_path__ + "static/media/wallet-express.bd69d1a8.svg";